import { useMemo } from 'react';
import { useData } from '@microsoft/teamsfx-react';

import useApi from 'src/hooks/useApi';
import { mapDevicesToIcons } from 'src/utils/iconUtils';
import { ImageIcon } from 'src/ui-models/Icon';

export const useDeviceIcons = (): {
  deviceIcons: ImageIcon[]
  loadDevicesError: unknown
  isLoadingDevices: boolean
} => {
  const apiHook = useApi();
  const { loading: isLoadingDevices, error: loadDevicesError, data: devices } = useData(apiHook.api.getDevices);
  const deviceIcons = useMemo(() => mapDevicesToIcons(devices), [devices]);

  return { deviceIcons, loadDevicesError, isLoadingDevices };
};
